import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-user\"><defs><style type=\"text/css\"></style></defs><path d=\"M219.428571 292.571429C219.428571 454.144 350.427429 585.142857 512 585.142857 673.572571 585.142857 804.571429 454.144 804.571429 292.571429 804.571429 130.998857 673.572571 0 512 0 350.427429 0 219.428571 130.998857 219.428571 292.571429L219.428571 292.571429 219.428571 292.571429ZM292.571429 658.285714C130.998857 658.285714 0 789.284571 0 950.857143L0 950.857143C0 991.252809 32.910537 1024 72.822649 1024L951.177351 1024C991.396191 1024 1024 991.27936 1024 950.857143L1024 950.857143C1024 789.284571 893.001143 658.285714 731.428571 658.285714L292.571429 658.285714 292.571429 658.285714Z\" p-id=\"7736\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user.svg
// module id = VdD3
// module chunks = 44